import type { SetupTemplatePreview as Preview } from "../../api.js";

export function SetupTemplatePreview({ preview }: { preview: Preview }) {
  return <section className="setup-template-preview" aria-labelledby="template-preview-title">
    <div><span>Draft preview</span><h3 id="template-preview-title">{preview.name}</h3><p>Nothing has been saved. Confirm dates and review settings before creating drafts.</p></div>
    <ol>{preview.phases.map((phase) => <li key={phase.stable_key}><div><strong>{phase.name}</strong><span>{phase.kind === "REVIEW" ? "Review round" : "Author phase"}</span></div></li>)}</ol>
    <p>{preview.review.criteria.join(" · ")}</p>
  </section>;
}
